<template>
  <div class="safetyInfoWrapper">
    <div class="topWrapper">
      <span class="title">安全等级：</span>
      <div class="safetyLevel">
        <div>
          <span :class="'level' + basicUserInfo.safetyLevel"></span>
          <span class="levelnum">{{ basicUserInfo.safetyLevel }}级</span>
        </div>
        <p>完成下方任务，提升安全等级</p>
      </div>
    </div>
    <div class="verifyWrapper">
      <div class="phoneVerify">
        <img class="phone" src="@/assets/imgs/safetyphone.png" alt="" />
        <div>
          <h3>手机验证</h3>
          <p>验证手机后，您可使用手机找回密码功能</p>
        </div>
        <span class="verifyed" v-if="basicUserInfo.phoneVerify == 1">已验证</span>
        <span class="goVerify" v-if="basicUserInfo.phoneVerify == 2" @click="verifyPhonePop = true">去认证</span>
      </div>
      <!-- 实人认证相关逻辑已注释
      <div class="humanVerify" v-if="$store.state.user.tenantId=='T0002'">
        <img class="user" src="@/assets/imgs/safetyuser.png" alt="" />
        <div>
          <h3>实人认证</h3>
          <p>实人认证后，您可使用积分支付功能</p>
        </div>
        <span class="verifyed" v-if="basicUserInfo.faceVerify == 1 || basicUserInfo.faceVerify == 3">已验证</span>
        <span class="goVerify" v-if="basicUserInfo.faceVerify == 2" @click="handleFacevalid">去认证</span>
      </div>
      -->
    </div>
    <!-- 手机验证弹窗 -->
    <el-dialog
      :lock-scroll="false"
      :visible.sync="verifyPhonePop"
      width="460px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleCloseVerifyPhone"
    >
      <div class="verifyPhoneDialog">
        <p class="title">手机验证</p>
        <p class="phoneNo">
          请您使用 <i>{{ basicUserInfo.phoneNo }}</i> 手机接收短信
        </p>
        <el-form
          ref="verifyPhoneForm"
          :rules="verifyPhoneFormRules"
          :model="verifyPhoneForm"
          label-position="left"
          label-width="110px"
        >
          <el-form-item label="验证码：" prop="smsCode">
            <el-input v-model="verifyPhoneForm.smsCode" style="width: 150px" placeholder="请输入验证码"></el-input>
            <el-button type="primary" style="margin-left: 10px" v-if="msgtime == 60" @click="getsmscode"
              >获取验证码</el-button
            >
            <el-button type="primary" style="margin-left: 10px" v-if="msgtime < 60">{{ msgtime }}s后重新获取</el-button>
          </el-form-item>
        </el-form>
        <div class="btngrouop">
          <span
            @click="
              verifyPhonePop = false;
              verifyPhoneForm.smsCode = '';
            "
          >
            取消</span
          >
          <span @click="handlesure">确认</span>
        </div>
      </div>
    </el-dialog>
    <!-- 实人认证弹窗已注释
    <DtPopup :isShow.sync="showQRcode" title="实人认证" @close="handleHumanValidclose" :footer="false">
      <div class="codeWrap" @click.stop>
        <img :src="QRcodeUrl" alt="" @click.stop />
        <p>打开微信扫描二维码穿越到手机<br />进行实人认证</p>
      </div>
    </DtPopup>
    -->
  </div>
</template>
<script>
import {
  userOneselfInfo,
  userSafetyInfosendsmsCode,
  userSafetyInfoverifyphone,
  // userSafetyInfoverifyface, // 实人认证相关API已注释
} from '@/api/userCenter';
import qs from 'qs';
import DtPopup from '@/components/layouts/DtPopup';
import { mapMutations } from 'vuex';

export default {
  components: {
    DtPopup,
  },
  data() {
    return {
      basicUserInfo: {},
      verifyPhonePop: false,
      verifyPhoneForm: {
        smsCode: '',
      },
      verifyPhoneFormRules: {
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      msgtime: 60,
      // showQRcode: false, // 实人认证相关数据已注释
      // QRcodeUrl: '', // 实人认证相关数据已注释
    };
  },
  // 实人认证相关watch已注释
  // watch: {
  //   '$store.state.user.bizTokenInfo'(newValue) {
  //     if (newValue && newValue.bizToken && newValue.type == 1) {
  //       this.handleHumanValidclose();
  //       this.init();
  //     }
  //   },
  // },
  methods: {
    ...mapMutations['user/setbizTokenInfo'],
    init() {
      userOneselfInfo({
        userId: this.$store.state.user.user.userId,
      }).then((res) => {
        if (res) {
          this.basicUserInfo = res;
        }
      });
    },
    getsmscode() {
      let that = this;
      userSafetyInfosendsmsCode(
        qs.stringify({
          userId: this.$store.state.user.user.userId,
        })
      ).then((res) => {
        if (res) {
          let time = 60;
          let t1 = setInterval(function () {
            time--;
            that.msgtime = time;
            if (time <= 0) {
              clearInterval(t1);
              that.msgtime = 60;
            }
          }, 1000);
        }
      });
    },
    handlesure() {
      this.$refs.verifyPhoneForm.validate((valid) => {
        if (valid) {
          userSafetyInfoverifyphone({
            userId: this.$store.state.user.user.userId,
            smsCode: this.verifyPhoneForm.smsCode,
          }).then((res) => {
            if (res) {
              this.init();
              this.verifyPhonePop = false;
            }
          });
        }
      });
    },
    // 实人认证相关方法已注释
    // handleFacevalid() {
    //   userSafetyInfoverifyface({
    //     userId: this.$store.state.user.user.userId,
    //     type: 1,
    //   }).then((res) => {
    //     if (res) {
    //       this.QRcodeUrl = res.url;
    //       this.showQRcode = true;
    //     }
    //   });
    // },
    // handleHumanValidclose() {
    //   this.showQRcode = false;
    // },
    handleCloseVerifyPhone(){
      this.verifyPhoneForm.smsCode = ''
    }
  },
  created() {
    this.init();
  },
};
</script>
<style lang="less" scoped>
.safetyInfoWrapper {
  margin-top: 30px;
  .topWrapper {
    // min-height: 100px;
    background: #fffbef;
    border: 1px solid #f3eede;
    padding: 30px;
    display: flex;
    .title {
      width: 100px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #55555a;
      line-height: 20px;
    }
    .safetyLevel {
      padding-top: 5px;
      > div {
        display: flex;
        margin-bottom: 16px;
        .level0 {
          width: 217px;
          height: 10px;
          background: url(~@/assets/imgs/level0.png);
          background-size: 100% 100%;
        }
        .level1 {
          width: 217px;
          height: 10px;
          background: url(~@/assets/imgs/level1.png);
          background-size: 100% 100%;
        }
        .level2 {
          width: 217px;
          height: 10px;
          background: url(~@/assets/imgs/level2.png);
          background-size: 100% 100%;
        }
        .levelnum {
          margin-left: 30px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #e27c00;
          //   line-height: 20px;
        }
      }
      > p {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #aaaaaf;
        line-height: 17px;
      }
    }
  }
  .verifyWrapper {
    .phoneVerify,
    .humanVerify {
      margin-top: 36px;
      display: flex;
      .phone {
        width: 50px;
        height: 50px;
        margin-right: 16px;
      }
      .user {
        width: 50px;
        height: 50px;
        margin-right: 16px;
      }
      > div {
        width: 380px;
        h3 {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #55555a;
          line-height: 18px;
          margin-bottom: 6px;
        }
        p {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #aaaaaf;
          line-height: 18px;
        }
      }
      .verifyed {
        width: 100px;
        height: 38px;
        background: #ffffff;
        border-radius: 19px;
        border: 1px solid #dcdce1;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #dcdce1;
        text-align: center;
        line-height: 38px;
      }
      .goVerify {
        width: 100px;
        height: 38px;
        background: #fff6e7;
        border-radius: 19px;
        border: 1px solid #e27c00;
        text-align: center;
        line-height: 38px;
        color: #e27c00;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        cursor: pointer;
      }
    }
  }
}
.verifyPhoneDialog {
  .title {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #382e2b;
  }
  .phoneNo {
    margin-top: 16px;
    margin-bottom: 44px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #55555a;
    i {
      color: rgba(87, 136, 187, 1);
    }
  }
  .btngrouop {
    margin-top: 44px;
    display: flex;
    justify-content: center;
    span {
      width: 160px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      color: #e27c00;
      cursor: pointer;
      &:nth-child(1) {
        border-radius: 2px;
        border: 1px solid #e27c00;
      }
      &:nth-child(2) {
        margin-left: 10px;
        background: #e27c00;
        border: 1px solid #e27c00;
        color: #ffffff;
      }
    }
  }
}
.codeWrap {
  text-align: center;
  padding-bottom: 50px;
  img {
    width: 200px;
    height: 200px;
    border: 5px solid #000;
    border-radius: 10px;
    margin: 10px 0;
  }
  p {
    color: #555;
    font-size: 16px;
    line-height: 1.5;
  }
  .claimCardList .claimTitle .iconLian[data-v-d870e762] {
    display: inline-block;
    vertical-align: top;
    margin-left: 1.067vw;
    width: 4.267vw;
    height: 4.267vw;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAGZklEQ…ZyV2ay/dJU1l+boxEoqy9OEgBZf3U2CkKWXp6OnYiz7fr8v+VIg/gO9qg/AAAAAElFTkSuQmCC)
      no-repeat;
    background-size: contain;
  }
}
</style>